
import {useEffect, useRef, useState} from "react";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
//import RootContext from "../types/RootContext";
import "assets/styles/test.css";

export default function HomePage() {
    return (
        //<Header isFirstSectionVisible={isVisible}/>
        <div>

            <Header />

            <div>

                <a href="/MiniKalkulator">
                    <button className={"gumb"}>
                        mini kalkulator
                    </button>


                </a>

            </div>
            <Footer />
        </div>
    );
}